import Phone from './index'
export default [
  {
    path: '/change/phone',
    name: 'leyousafe-change-phone',
    component: Phone
  },
]
